module.exports = __webpack_public_path__ + "static/media/Thanksgiving_popup.6ee1808b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Thanksgiving_popup.png
// module id = 693
// module chunks = 0